<template>
    <div class="persondata">
        <home-nav></home-nav>
        <div class="persondata-box">
            <div class="persondata-left">
                <div class="persondata-top"
                     :class="isFirst ? 'persondata-top-ac' : ''"
                     @click="persondataFirst"
                >
                    个人中心首页
                </div>
                <div class="persondata-list">
                    <div class="persondata-list-box">
                        <div class="persondata-list-title" @click="openClick(0)">
                            <img class="persondata-list-icon" :src="(currentLi == 0 && isOpenZero) ? jianIcon : jiaIcon" alt="">
                            <span class="persondata-list-text">所有订单</span>
                        </div>
                        <ul class="persondata-list-ul" v-show="currentLi == 0 && isOpenZero">
                            <li class="persondata-list-li" @click="liClick(101)" :class="liCurrentNum == 101 ? 'li-active' : ''">包车订单</li>
                            <!--<li class="persondata-list-li" @click="liClick(102)" :class="liCurrentNum == 102 ? 'li-active' : ''">旅游订单</li>-->
                        </ul>
                    </div>

                    <div class="persondata-list-box">
                        <div class="persondata-list-title" @click="openClick(1)">
                            <img class="persondata-list-icon" :src="(currentLi == 1 && isOpenOne) ? jianIcon : jiaIcon" alt="">
                            <span class="persondata-list-text">我的收藏</span>
                        </div>
                        <ul class="persondata-list-ul" v-show="currentLi == 1 && isOpenOne">
                            <li class="persondata-list-li" @click="liClick(11)" :class="liCurrentNum == 11 ? 'li-active' : ''">包车</li>
                            <!--<li class="persondata-list-li" @click="liClick(12)" :class="liCurrentNum == 12 ? 'li-active' : ''">旅游</li>-->
                        </ul>
                    </div>

                    <div class="persondata-list-box">
                        <div class="persondata-list-title" @click="openClick(2)">
                            <img class="persondata-list-icon" :src="(currentLi == 2 && isOpenTwo) ? jianIcon : jiaIcon" alt="">
                            <span class="persondata-list-text">个人信息</span>
                        </div>
                        <ul class="persondata-list-ul" v-show="currentLi == 2 && isOpenTwo">
                            <li class="persondata-list-li" @click="liClick(2)" :class="liCurrentNum == 2 ? 'li-active' : ''">个人资料</li>
                        </ul>
                    </div>

                    <div class="persondata-list-box">
                        <div class="persondata-list-title" @click="openClick(3)">
                            <img class="persondata-list-icon" :src="(currentLi == 3 && isOpenThree) ? jianIcon : jiaIcon" alt="">
                            <span class="persondata-list-text">我的发票</span>
                        </div>
                        <ul class="persondata-list-ul" v-show="currentLi == 3 && isOpenThree">
                            <li class="persondata-list-li" @click="liClick(3)" :class="liCurrentNum == 3 ? 'li-active' : ''">发票记录</li>
                        </ul>
                    </div>

                    <div class="persondata-list-box">
                        <div class="persondata-list-title" @click="openClick(4)">
                            <img class="persondata-list-icon" :src="(currentLi == 4 && isOpenFour) ? jianIcon : jiaIcon" alt="">
                            <span class="persondata-list-text">消息管理</span>
                        </div>
                        <ul class="persondata-list-ul" v-show="currentLi == 4 && isOpenFour">
                            <li class="persondata-list-li" @click="liClick(41)" :class="liCurrentNum == 41 ? 'li-active' : ''">全部评价</li>
                            <li class="persondata-list-li" @click="liClick(42)" :class="liCurrentNum == 42 ? 'li-active' : ''">全部投诉</li>
                        </ul>
                    </div>

                    <div class="persondata-list-box">
                        <div class="persondata-list-title" @click="openClick(5)">
                            <img class="persondata-list-icon" :src="(currentLi == 5 && isOpenFive) ? jianIcon : jiaIcon" alt="">
                            <span class="persondata-list-text">账号管理</span>
                        </div>
                        <ul class="persondata-list-ul" v-show="currentLi == 5 && isOpenFive">
                            <li class="persondata-list-li" @click="liClick(51)" :class="liCurrentNum == 51 ? 'li-active' : ''">绑定信息</li>
                            <li class="persondata-list-li" @click="liClick(52)" :class="liCurrentNum == 52 ? 'li-active' : ''">修改密码</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="persondata-right">
                <router-view></router-view>
            </div>
        </div>

        <home-footer></home-footer>
    </div>
</template>

<script>
    import HomeNav from '@/components/homeNav';
    import HomeFooter from '@/components/homeFooter';
    export default {
        name: "persondata",
        components: {
            HomeNav,
            HomeFooter
        },
        data() {
            return {
                jiaIcon: require('@/assets/images/persondata/personal_icon_shou.png'),
                jianIcon: require('@/assets/images/persondata/personal_icon_zhankai.png'),
                isFirst: true,
                currentLi: -1,
                isOpenZero: false,
                isOpenOne: false,
                isOpenTwo: false,
                isOpenThree: false,
                isOpenFour: false,
                isOpenFive: false,

                liCurrentNum: -1,
            }
        },
        mounted(){
            window.scrollTo(0, 0);
            this.getUrlCurrentPer();
        },
        methods: {
            getUrlCurrentPer() {
                /*概览*/
                var that = this;
                var currentUrl = this.$route.path;
                if (currentUrl.search('/persondata') != -1 || currentUrl.search('/persondatahome') != -1) {
                    that.liCurrentNum = -1;
                    that.isFirst = true;

                    that.isOpenZero = false;
                    that.isOpenOne = false;
                    that.isOpenTwo = false;
                    that.isOpenThree = false;
                    that.isOpenFour = false;
                    that.isOpenFive = false;
                } else if (currentUrl.search('/orderdetail') != -1) {
                    that.liCurrentNum = 101;
                    that.isFirst = false;

                    that.currentLi = 0;
                    that.isOpenZero = true;
                    that.isOpenOne = false;
                    that.isOpenTwo = false;
                    that.isOpenThree = false;
                    that.isOpenFour = false;
                    that.isOpenFive = false;
                } else if (currentUrl.search('/travelorder') != -1) {
                    that.liCurrentNum = 102;
                    that.isFirst = false;

                    that.currentLi = 0;
                    that.isOpenZero = true;
                    that.isOpenOne = false;
                    that.isOpenTwo = false;
                    that.isOpenThree = false;
                    that.isOpenFour = false;
                    that.isOpenFive = false;
                } else if (currentUrl.search('/collection') != -1) {
                    that.liCurrentNum = 11;
                    that.isFirst = false;

                    that.currentLi = 1;
                    that.isOpenZero = false;
                    that.isOpenOne = true;
                    that.isOpenTwo = false;
                    that.isOpenThree = false;
                    that.isOpenFour = false;
                    that.isOpenFive = false;
                } else if (currentUrl.search('/travelcol') != -1) {
                    that.liCurrentNum = 12;
                    that.isFirst = false;

                    that.currentLi = 1;
                    that.isOpenZero = false;
                    that.isOpenOne = true;
                    that.isOpenTwo = false;
                    that.isOpenThree = false;
                    that.isOpenFour = false;
                    that.isOpenFive = false;
                } else if (currentUrl.search('/individual') != -1) {
                    that.liCurrentNum = 2;
                    that.isFirst = false;

                    that.currentLi = 2;
                    that.isOpenZero = false;
                    that.isOpenOne = false;
                    that.isOpenTwo = true;
                    that.isOpenThree = false;
                    that.isOpenFour = false;
                    that.isOpenFive = false;
                } else if (currentUrl.search('/invoice') != -1) {
                    that.liCurrentNum = 3;
                    that.isFirst = false;

                    that.currentLi = 3;
                    that.isOpenZero = false;
                    that.isOpenOne = false;
                    that.isOpenTwo = false;
                    that.isOpenThree = true;
                    that.isOpenFour = false;
                    that.isOpenFive = false;
                } else if (currentUrl.search('/evaluate') != -1) {
                    that.liCurrentNum = 41;
                    that.isFirst = false;

                    that.currentLi = 4;
                    that.isOpenZero = false;
                    that.isOpenOne = false;
                    that.isOpenTwo = false;
                    that.isOpenThree = false;
                    that.isOpenFour = true;
                    that.isOpenFive = false;
                } else if (currentUrl.search('/complaint') != -1) {
                    that.liCurrentNum = 42;
                    that.isFirst = false;

                    that.currentLi = 4;
                    that.isOpenZero = false;
                    that.isOpenOne = false;
                    that.isOpenTwo = false;
                    that.isOpenThree = false;
                    that.isOpenFour = true;
                    that.isOpenFive = false;
                } else if (currentUrl.search('/binding') != -1) {
                    that.liCurrentNum = 51;
                    that.isFirst = false;

                    that.currentLi = 5;
                    that.isOpenZero = false;
                    that.isOpenOne = false;
                    that.isOpenTwo = false;
                    that.isOpenThree = false;
                    that.isOpenFour = false;
                    that.isOpenFive = true;
                } else if (currentUrl.search('/modify') != -1) {
                    that.liCurrentNum = 52;
                    that.isFirst = false;

                    that.currentLi = 5;
                    that.isOpenZero = false;
                    that.isOpenOne = false;
                    that.isOpenTwo = false;
                    that.isOpenThree = false;
                    that.isOpenFour = false;
                    that.isOpenFive = true;
                }
            },
            persondataFirst() {
                this.liCurrentNum = -1
                this.isOpenZero = false;
                this.isOpenOne = false;
                this.isOpenTwo = false;
                this.isOpenThree = false;
                this.isOpenFour = false;
                this.isOpenFive = false;
                if(this.isFirst){
                    return
                } else {
                    this.isFirst = true;
                    this.$router.push({path: '/persondata'});
                }
            },


            liClick(number) {
                var that = this;
                var currentUrl = this.$route.path;
                that.isFirst = false;
                switch (number) {
                    case 101:
                        if (currentUrl.search('/orderdetail') != -1) {
                            return;
                        } else {
                            that.$router.push({path: '/orderdetail'});
                            that.liCurrentNum = number;
                        }
                        break;
                    case 102:
                        if (currentUrl.search('/travelorder') != -1) {
                            return;
                        } else {
                            that.$router.push({path: '/travelorder'});
                            that.liCurrentNum = number;
                        }
                        break;
                    case 11:
                        if (currentUrl.search('/collection') != -1) {
                            return;
                        } else {
                            that.$router.push({path: '/collection'});
                            that.liCurrentNum = number;
                        }
                        break;
                    case 12:
                        if (currentUrl.search('/travelcol') != -1) {
                            return;
                        } else {
                            that.$router.push({path: '/travelcol'});
                            that.liCurrentNum = number;
                        }
                        break;
                    case 2:
                        if (currentUrl.search('/individual') != -1) {
                            return;
                        } else {
                            that.$router.push({path: '/individual'});
                            that.liCurrentNum = number;
                        }
                        break;
                    case 3:
                        if (currentUrl.search('/invoice') != -1) {
                            return;
                        } else {
                            that.$router.push({path: '/invoice'});
                            that.liCurrentNum = number;
                        }
                        break;
                    case 41:
                        if (currentUrl.search('/evaluate') != -1) {
                            return;
                        } else {
                            that.$router.push({path: '/evaluate'});
                            that.liCurrentNum = number;
                        }
                        break;
                    case 42:
                        if (currentUrl.search('/complaint') != -1) {
                            return;
                        } else {
                            that.$router.push({path: '/complaint'});
                            that.liCurrentNum = number;
                        }
                        break;
                    case 51:
                        if (currentUrl.search('/binding') != -1) {
                            return;
                        } else {
                            that.$router.push({path: '/binding'});
                            that.liCurrentNum = number;
                        }
                        break;
                    case 52:
                        if (currentUrl.search('/modify') != -1) {
                            return;
                        } else {
                            that.$router.push({path: '/modify'});
                            that.liCurrentNum = number;
                        }
                        break;
                }
            },

            openClick(num){
                this.currentLi = num;
                if(num == 0){
                    this.isOpenOne = false;
                    this.isOpenTwo = false;
                    this.isOpenThree = false;
                    this.isOpenFour = false;
                    this.isOpenFive = false;
                    if(this.isOpenZero){
                        this.isOpenZero = false;
                    } else {
                        this.isOpenZero = true;
                    }
                } else if(num == 1){
                    this.isOpenZero = false;
                    this.isOpenTwo = false;
                    this.isOpenThree = false;
                    this.isOpenFour = false;
                    this.isOpenFive = false;
                    if(this.isOpenOne){
                        this.isOpenOne = false;
                    } else {
                        this.isOpenOne = true;
                    }
                } else if(num == 2){
                    this.isOpenZero = false;
                    this.isOpenOne = false;
                    this.isOpenThree = false;
                    this.isOpenFour = false;
                    this.isOpenFive = false;
                    if(this.isOpenTwo){
                        this.isOpenTwo = false;
                    } else {
                        this.isOpenTwo = true;
                    }
                } else if(num == 3){
                    this.isOpenZero = false;
                    this.isOpenOne = false;
                    this.isOpenTwo = false;
                    this.isOpenFour = false;
                    this.isOpenFive = false;
                    if(this.isOpenThree){
                        this.isOpenThree = false;
                    } else {
                        this.isOpenThree = true;
                    }
                } else if(num == 4){
                    this.isOpenZero = false;
                    this.isOpenOne = false;
                    this.isOpenTwo = false;
                    this.isOpenThree = false;
                    this.isOpenFive = false;
                    if(this.isOpenFour){
                        this.isOpenFour = false;
                    } else {
                        this.isOpenFour = true;
                    }
                } else if(num == 5){
                    this.isOpenZero = false;
                    this.isOpenOne = false;
                    this.isOpenTwo = false;
                    this.isOpenThree = false;
                    this.isOpenFour = false;
                    if(this.isOpenFive){
                        this.isOpenFive = false;
                    } else {
                        this.isOpenFive = true;
                    }
                }
            }
        }
    }
</script>

<style scoped>
    @import './persondata.css';
</style>


// WEBPACK FOOTER //
// src/pages/persondata/persondata.vue